import { useCallback, Suspense } from 'react'

function useLazyMiddleware({ fallback }) {
  const middleware = useCallback((children) => <Suspense fallback={fallback}>{children}</Suspense>, [fallback])

  return middleware
}

export default useLazyMiddleware
